var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    [
      _c(
        "template",
        { slot: "header" },
        [_c("Title", { attrs: { title: "Abrir ticket de suporte" } })],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "body" }, [
        _c("iframe", {
          staticClass: "support",
          attrs: {
            title: "Contact Form",
            src:
              "https://plugins.crisp.chat/urn:crisp.im:contact-form:0/contact/187a1456-9194-49dc-8b77-5b5e6ddb4139",
            referrerpolicy: "origin",
            sandbox: "allow-forms allow-popups allow-scripts allow-same-origin",
            width: "100%",
            height: "600px",
            frameborder: "0"
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "footer" },
        [
          _c("Tip", [
            _vm._v(
              "\n      Utilize o formulário acima ou o nosso chat para falar com o nosso suporte\n    "
            )
          ]),
          _vm._v(" "),
          _c("Tip", { attrs: { type: "alert", size: "small" } }, [
            _vm._v(
              "\n      Se precisar enviar algum arquivo, como comprovantes, utilize o chat\n    "
            )
          ]),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "btn bg-purple", on: { click: _vm.openChat } },
            [_c("span", [_vm._v("\n        abrir chat\n      ")])]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn bg-outlined",
              on: {
                click: function($event) {
                  _vm.$emit("close")
                }
              }
            },
            [_c("span", [_vm._v("\n        fechar\n      ")])]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f4babd1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4babd1c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Support/Index.vue
// module id = null
// module chunks = 